import React, { useContext, useMemo } from "react";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { DarkModeContext } from "../context/darkModeContext";
import { buildTheme } from "./muiTheme";

/**
 * Bridges the app's dark-mode context into MUI. The CSS custom properties are
 * applied by DarkModeContextProvider (via data-theme on <html>); this only
 * hands MUI the matching palette so its own colour maths lines up.
 */
const AppThemeProvider = ({ children }) => {
  const { darkMode } = useContext(DarkModeContext);
  const theme = useMemo(() => buildTheme(darkMode ? "dark" : "light"), [darkMode]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
};

export default AppThemeProvider;
